<template>
  <div class="member-card-list">
    <h2>会员卡列表</h2>
    <el-card shadow="hover">
      <template #header>
        <div class="card-header">
          <span>消费系统会员卡列表</span>
        </div>
      </template>
      <div class="card-list-content">
        <!-- 搜索区域 -->
        <div class="search-area">
          <el-input
            v-model="searchForm.phone"
            placeholder="请输入用户手机号"
            prefix-icon="Phone"
            clearable
            class="search-input"
            style="width: 200px; margin-right: 10px"
          />
          <el-input
            v-model="searchForm.cardNumber"
            placeholder="请输入会员卡卡号"
            prefix-icon="CreditCard"
            clearable
            class="search-input"
            style="width: 200px; margin-right: 10px"
          >
            <template #append>
              <el-button type="primary" @click="handleSearch">
                <el-icon><Search /></el-icon>
                搜索
              </el-button>
            </template>
          </el-input>
        </div>

        <!-- 数据表格 -->
        <el-table
          v-loading="loading"
          :data="cardList"
          stripe
          style="width: 100%"
          class="card-table"
          :row-key="row => row.id"
        >
          <el-table-column prop="id" label="ID" width="80" />
          <el-table-column prop="card_number" label="卡号" width="180" />
          <el-table-column prop="card_type" label="卡类型" width="120" />
          <el-table-column prop="phone" label="用户手机号" width="150" />
          <el-table-column prop="balance" label="当前余额" width="120">
            <template #default="scope">
              {{ scope.row.balance }} 元
            </template>
          </el-table-column>
          <el-table-column prop="issue_date" label="发卡日期" width="180" />
          <el-table-column prop="expiry_date" label="有效期至" width="180" />
          <el-table-column prop="status" label="状态" width="100">
            <template #default="scope">
              <el-tag :type="scope.row.status === '1' ? 'success' : 'danger'">
                {{ scope.row.status === '1' ? '启用' : '禁用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150" fixed="right">
            <template #default="scope">
              <el-button
                type="primary"
                size="small"
                @click="handleViewDetails(scope.row)"
              >
                <el-icon><View /></el-icon>
                详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-area">
          <el-pagination
            :current-page="pagination.currentPage"
            :page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </el-card>

    <!-- 会员卡详情弹窗 -->
    <el-dialog
      v-model="detailDialogVisible"
      title="会员卡详情"
      width="60%"
    >
      <div v-if="currentCard" class="card-detail">
        <h3>会员卡基本信息</h3>
        <el-descriptions :column="2" border>
          <el-descriptions-item label="卡号">{{ currentCard.card_number }}</el-descriptions-item>
          <el-descriptions-item label="卡类型">{{ currentCard.card_type }}</el-descriptions-item>
          <el-descriptions-item label="当前余额">{{ currentCard.balance }} 元</el-descriptions-item>
          <el-descriptions-item label="状态">{{ currentCard.status === '1' ? '启用' : '禁用' }}</el-descriptions-item>
          <el-descriptions-item label="发卡日期">{{ currentCard.issue_date }}</el-descriptions-item>
          <el-descriptions-item label="有效期至">{{ currentCard.expiry_date }}</el-descriptions-item>
        </el-descriptions>

        <h3>用户信息</h3>
        <el-descriptions :column="2" border>
          <el-descriptions-item label="手机号">{{ currentCard.phone || '未关联手机号' }}</el-descriptions-item>
        </el-descriptions>

        <!-- 消费记录暂时隐藏，因为会员卡不再直接关联用户 -->
        <!-- <h3>消费记录</h3>
        <el-table
          :data="currentCard.user?.consumptions || []"
          stripe
          style="width: 100%"
          class="consumption-table"
          :row-key="row => row.id"
        >
          <el-table-column prop="id" label="ID" width="80" />
          <el-table-column prop="type" label="消费类型" width="120" />
          <el-table-column prop="total_amount" label="消费金额" width="120">
            <template #default="scope">
              {{ scope.row.total_amount }} 元
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="100" />
          <el-table-column prop="created_at" label="消费时间" width="180" />
        </el-table> -->
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="detailDialogVisible = false">关闭</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, reactive, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import { Search, View } from '@element-plus/icons-vue';
import request from '../../api/axios';

export default {
  name: 'MemberCardList',
  components: {
    Search,
    View
  },
  setup() {
    // 加载状态
    const loading = ref(false);
    // 会员卡列表
    const cardList = ref([]);
    // 分页数据
    const pagination = reactive({
      currentPage: 1,
      pageSize: 10,
      total: 0,
    });
    // 搜索表单
    const searchForm = reactive({
      phone: '',
      cardNumber: '',
    });
    // 详情弹窗
    const detailDialogVisible = ref(false);
    // 当前选中的会员卡
    const currentCard = ref(null);

    // 获取会员卡列表
    const fetchCards = async () => {
      loading.value = true;
      try {
        const response = await request({
          url: '/manage/member-cards',
          method: 'get',
          params: {
            page: pagination.currentPage,
            pageSize: pagination.pageSize,
            phone: searchForm.phone,
            card_number: searchForm.cardNumber,
          },
        });
        cardList.value = response.data.data || [];
        pagination.total = response.data.total || 0;
      } catch (error) {
        ElMessage.error('获取会员卡列表失败');
        console.error(error);
      } finally {
        loading.value = false;
      }
    };

    // 搜索会员卡
    const handleSearch = () => {
      pagination.currentPage = 1;
      fetchCards();
    };



    // 查看会员卡详情
    const handleViewDetails = async (row) => {
      try {
        const response = await request({
          url: `/manage/member-cards/${row.id}`,
          method: 'get',
        });
        currentCard.value = response.data;
        detailDialogVisible.value = true;
      } catch (error) {
        ElMessage.error('获取会员卡详情失败');
        console.error(error);
      }
    };

    // 分页大小变化
    const handleSizeChange = (size) => {
      pagination.pageSize = size;
      fetchCards();
    };

    // 当前页变化
    const handleCurrentChange = (current) => {
      pagination.currentPage = current;
      fetchCards();
    };

    // 组件挂载时加载数据
    onMounted(() => {
      fetchCards();
    });

    return {
      loading,
      cardList,
      pagination,
      searchForm,
      detailDialogVisible,
      currentCard,
      handleSearch,
      handleViewDetails,
      handleSizeChange,
      handleCurrentChange,
    };
  },
};
</script>

<style scoped>
.member-card-list {
  padding: 20px;
}

.member-card-list h2 {
  margin-bottom: 20px;
  color: #333;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.card-list-content {
  margin-top: 20px;
}

.search-area {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.search-input {
  width: 250px;
}

.card-table {
  margin-bottom: 20px;
}

.pagination-area {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.card-detail {
  padding: 10px;
}

.card-detail h3 {
  margin: 20px 0 10px 0;
  font-size: 16px;
  color: #333;
}

.consumption-table {
  margin-top: 10px;
}
</style>
